<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜索条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="物料编码">
                            <el-input v-model="q.materialCode" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="物料名称">
                            <el-input v-model="q.materialName" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="客户编码">
                            <el-input v-model="q.customerCode" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="客户名称">
                            <el-input v-model="q.customerName" :clearable="true"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="queryPage">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                        <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createOrderSalsePrice">新增</el-button>
                    </div>
                </div>
            </div>

            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        stripe
                        border
                        style="width: 100%">
                    <el-table-column type="index" width="50" label="序号" fixed></el-table-column>
                    <el-table-column prop="materialCode" label="物料编码" :show-overflow-tooltip="true" width="140"></el-table-column>
                    <el-table-column prop="materialName" label="物料名称" show-overflow-tooltip width="180"></el-table-column>
                    <el-table-column prop="customerCode" label="客户编码" width="150"></el-table-column>
                    <el-table-column prop="customerName" label="客户名称" show-overflow-tooltip width="180"></el-table-column>
                    <el-table-column prop="cuname" label="创建人名称" width="110"></el-table-column>
                    <el-table-column prop="cdate" label="创建时间" :formatter="formatDatecc" width="130"></el-table-column>
                    <el-table-column label="最后更新人" width="110">
                        <template slot-scope="scope">{{ scope.row.luname || scope.row.lucode }}</template>
                    </el-table-column>
                    <el-table-column prop="ldate" label="最后更新时间" :formatter="formatDatecc" width="130"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="130">
                        <template slot-scope="scope">
                            <div style="text-align: left;">
                                <el-button type="text" size="small" class="h-tableLink h-btn" @click="toChange(scope.row)">编辑</el-button>
                                <el-button type="text" size="small" class="h-tableLink h-btn" @click="toSee(scope.row)">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL"></div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="queryPage" />
                    </div>
                </div>

                <!-- 新增/修改弹窗 -->
                <el-dialog :close-on-click-modal="false" @close="closeDialog" :visible.sync="newDialog" class="h-dialog2">
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>{{ titleDig }}</h1>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLines">
                        <el-form ref="form" :model="addForm" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                            <el-form-item label="物料编码" class="h-elformWrap-2" prop="materialCode"
                                          :rules="[{ required: true, message: '请输入物料编码', trigger: 'blur' }]">
                                <el-select placeholder="请选择" filterable clearable v-model="addForm.materialCode" @change="fillProduct">
                                    <el-option v-for="pro in gkProductList" :key="pro.materialCode"
                                               :label="pro.materialCode" :value="pro.materialCode"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="物料名称" class="h-elformWrap-2" label-width="100" prop="materialName"
                                          :rules="[{ required: true, message: '请输入物料名称', trigger: 'blur' }]">
                                <el-input v-model="addForm.materialName" style="width: 84%;" disabled clearable></el-input>
                            </el-form-item>
                            <el-form-item label="客户名称" class="h-elformWrap-2" prop="customerCode"
                                          :rules="[{ required: true, message: '请选择客户', trigger: 'blur' }]">
                                <el-select placeholder="请选择" filterable clearable v-model="addForm.customerCode" @change="fillCusName">
                                    <el-option v-for="customer in customerList" :key="customer.usercode"
                                               :label="customer.username + '-' + customer.usercode" :value="customer.usercode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                        <div style="display:flex;justify-content:center;margin-bottom:20px">
                            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="save">提交</el-button>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from "../../../api/SystemService";

    export default {
        data() {
            return {
                q: {
                    materialCode: null,
                    materialName: null,
                    customerCode: null,
                    customerName: null,
                    delflag: 1,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                tableData: [],
                newDialog: false,
                titleDig: "",
                customerList: [],
                gkProductList: [],
                addForm: {
                    id: null,
                    cucode: null,
                    cuname: null,
                    cdate: null,
                    lucode: null,
                    ldate: null,
                    delflag: null,
                    materialCode: null,
                    materialName: null,
                    customerCode: null,
                    customerName: null,
                },
            }
        },
        created() {
            this.queryPage();
            this.getCustomerList();
            this.getGkProductList();
        },
        methods: {
            // 客户集合
            getCustomerList() {
                ss.contractService.getCustomerList({ usertype: 1, delflag: 1 }).then(rd => {
                    this.customerList = rd || [];
                });
            },
            // 客户集合
            getGkProductList() {
                ss.GKOrderPage.getGkProductList().then(rd => {
                    this.gkProductList = rd.obj || [];
                });
            },
            // 查询
            queryPage() {
                ss.GKOrderPage.gkAgentMaterialSelect(this.q).then(res => {
                    this.q.total = res.total;
                    this.tableData = res.records;
                });
            },
            // 重置（保留分页）
            resetData() {
                const pageSize = this.q.pageSize;
                const pageNo = this.q.pageNo;
                const total = this.q.total;
                this.q = {
                    materialCode: null,
                    materialName: null,
                    customerCode: null,
                    customerName: null,
                    delflag: 1,
                    pageSize: pageSize,
                    pageNo: pageNo,
                    total: total,
                };
                this.queryPage();
            },
            // 日期格式化
            formatDatecc(row, column) {
                const data = row[column.property];
                if (data == null || data == '') return null;
                return this.$util.riQi3(new Date(data));
            },
            // 选择客户，回填客户名称
            fillCusName(data) {
                const obj = this.customerList.find(item => item.usercode === data);
                if (obj != undefined) {
                    this.addForm.customerCode = obj.usercode;
                    this.addForm.customerName = obj.username;
                } else {
                    this.addForm.customerCode = null;
                    this.addForm.customerName = null;
                }
            },
            fillProduct(data) {
                const obj = this.gkProductList.find(item => item.materialCode === data);
                if (obj != undefined) {
                    this.addForm.materialCode = obj.materialCode;
                    this.addForm.materialName = obj.materialName;
                } else {
                    this.addForm.materialCode = null;
                    this.addForm.materialName = null;
                }
            },
            // 编辑
            toChange(row) {
                ss.GKOrderPage.gkAgentMaterialSelectById(row.id).then(res => {
                    if (res.f) {
                        this.addForm = res.obj;
                        this.titleDig = "修改产品";
                        this.newDialog = true;
                    } else {
                        this.$msg.msge("获取信息失败!");
                    }
                });
            },
            // 删除
            toSee(row) {
                ss.GKOrderPage.gkAgentMaterialDeleteById(row.id).then(res => {
                    if (res.f) {
                        this.$alert("删除成功", '提示', { confirmButtonText: '确定' });
                        this.queryPage();
                    } else {
                        this.$msg.msge("删除失败!");
                    }
                });
            },
            // 打开新增
            createOrderSalsePrice() {
                this.titleDig = "新增产品";
                this.newDialog = true;
            },
            closeDialog() {
                this.newDialog = false;
                this.addForm = {
                    id: null,
                    cucode: null,
                    cuname: null,
                    cdate: null,
                    lucode: null,
                    ldate: null,
                    delflag: null,
                    materialCode: null,
                    materialName: null,
                    customerCode: null,
                    customerName: null,
                };
                this.$nextTick(() => {
                    this.$refs.form && this.$refs.form.clearValidate();
                });
            },
            exit() {
                this.closeDialog();
            },
            save() {
                this.$refs.form.validate(valid => {
                    if (!valid) return;
                    if (this.titleDig == '修改产品') {
                        ss.GKOrderPage.gkAgentMaterialUpdateById(this.addForm).then(res => {
                            if (res.f) {
                                this.$alert("修改成功", '提示', { confirmButtonText: '确定' });
                                this.newDialog = false;
                                this.queryPage();
                            } else {
                                this.$msg.msge(res.msg);
                            }
                        });
                    } else {
                        ss.GKOrderPage.gkAgentMaterialInsert(this.addForm).then(res => {
                            if (res.f) {
                                this.$alert("保存成功", '提示', { confirmButtonText: '确定' });
                                this.newDialog = false;
                                this.queryPage();
                            } else {
                                this.$msg.msge(res.msg);
                            }
                        });
                    }
                });
            },
        },
    }
</script>

<style scoped></style>
